import { Checkbox, Stack } from '@tonic-one/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ReportContentItems,
  ReportContentItemsKey,
} from '../../../types/report';
import { REPORT_CONTENT_ITEMS } from '../../../utils/enums';

const ReportContentCheckbox = memo(
  (props: {
    reportContent: ReportContentItems;
    setReportContent: (value: ReportContentItems) => void;
  }) => {
    const { t } = useTranslation();
    const { reportContent, setReportContent } = props;

    const handleChange = (e: any) => {
      const checked: boolean = e.target.checked;
      const value: ReportContentItemsKey = e.target.value;
      setReportContent({ ...reportContent, [value]: checked });
    };

    return (
      <>
        <Stack
          direction="column"
          spacing="3x"
          shouldWrapChildren
          paddingTop="6px"
        >
          {REPORT_CONTENT_ITEMS.map((item) => {
            return (
              <Checkbox
                key={item}
                value={item}
                checked={props.reportContent[item]}
                onChange={(e: any) => handleChange(e)}
                disabled={item === 'total'}
              >
                {t(`reportCommon.content.${item}`)}
              </Checkbox>
            );
          })}
        </Stack>
      </>
    );
  }
);

export default ReportContentCheckbox;
